import { useState } from "react";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function useWidgetAddWidgetSizeState({
  widgetSizes,
  maxSize,
  defaultSize,
}: {
  widgetSizes: WidgetSizeT[];
  maxSize: WidgetSizeT;
  defaultSize?: WidgetSizeT;
}) {
  const [sizeWithinBounds, hasSizeWithinBounds] =
    getWidgetAddWidgetSizeWithinBounds({
      widgetSizes,
      maxSize,
      defaultSize,
    });
  return [
    ...useState<WidgetSizeT>(sizeWithinBounds),
    hasSizeWithinBounds,
  ] as const;
}

export function getWidgetAddWidgetSizeWithinBounds({
  widgetSizes,
  maxSize,
  defaultSize,
}: {
  widgetSizes: WidgetSizeT[];
  maxSize: WidgetSizeT;
  defaultSize?: WidgetSizeT;
}) {
  if (defaultSize && defaultSize.w <= maxSize.w && defaultSize.h <= maxSize.h) {
    return [defaultSize, true] as const;
  }

  const widgetSizesWithinBounds = widgetSizes.filter(
    (size) => size.w <= maxSize.w && size.h <= maxSize.h
  );

  if (widgetSizesWithinBounds.length === 0) {
    return [widgetSizes[0], false] as const;
  }

  return [
    widgetSizesWithinBounds[widgetSizesWithinBounds.length - 1],
    true,
  ] as const;
}
